import EmailSubjectTemplate from './EmailSubjectTemplate';

export { EmailSubjectTemplate };
export default EmailSubjectTemplate;
